export default __webpack_public_path__ + "static/terreo-e4b0517aa06e69f5952d3ba56d5bdc4f.jpg";